import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import useOnMount from "@cdkglobal/epay-admin-component/cjs/components/_onePay/common/hook/UseOnMount";
import AdminService from "../../services/admin/AdminService";

import NavigationPanel from "@cdkglobal/epay-admin-component/cjs/components/_onePay/middle/NavigationPanel";

import AdminPage from "./common/AdminPage";

const NavigationPage = ({ history }) => {
  const [navigationPanelConfig, setNavigationPanelConfig] = useState({});

  useOnMount(() => {
    AdminService.config()
      .then(result => {
        const config = {};
        for (let val of result.permissions)
          config[val] = { onClick: () => history.push(`/${val}`) };
        setNavigationPanelConfig(config);
      })
      .catch(e => {
        console.error(e);
      });
  });

  return (
    <AdminPage>
      <div style={{ paddingTop: "100px" }}>
        <NavigationPanel {...navigationPanelConfig} />
      </div>
    </AdminPage>
  );
};

export default withRouter(NavigationPage);
